// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Dashboard ======
function deadlinePillClass(g) {
  if (g === null) return '';
  if (g < 0) return 'dl-danger';
  if (g <= 30) return 'dl-warn';
  return 'dl-ok';
}

function formatGiorni(g) {
  if (g === null) return '';
  if (g < 0) return `Scaduto ${-g}gg fa`;
  if (g === 0) return 'Oggi';
  if (g === 1) return 'Domani';
  return `Tra ${g}gg`;
}

function renderBarChart(counts) {
  // Fallback HTML usato solo se Chart.js non è caricato.
  const entries = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  if (!entries.length) return '<p class="muted">Nessun dato</p>';
  const max = Math.max(...entries.map((e) => e[1]));
  return (
    '<div class="bar-chart">' +
    entries
      .map(
        ([label, val]) => `
    <div class="bar-row">
      <div class="bar-label">${escapeHtml(label)}</div>
      <div class="bar-track"><div class="bar-fill" style="width:${((val / max) * 100).toFixed(1)}%"></div></div>
      <div class="bar-value">${val}</div>
    </div>`
      )
      .join('') +
    '</div>'
  );
}

function renderChartIn(containerId, counts, canvasId) {
  const container = document.getElementById(containerId);
  if (!container) return;
  const entries = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  if (!entries.length) {
    container.innerHTML = '<p class="muted">Nessun dato</p>';
    return;
  }
  if (typeof Chart !== 'undefined') {
    container.innerHTML = `<div class="chart-container"><canvas id="${canvasId}"></canvas></div>`;
    renderChartBar(
      canvasId,
      entries.map(([l, v]) => ({ label: l, value: v }))
    );
  } else {
    container.innerHTML = renderBarChart(counts);
  }
}

function collectActions() {
  const out = [];
  state.clients.forEach((c) => {
    Object.entries(c.accessi || {}).forEach(([res, stato]) => {
      if (ACTION_STATUSES.includes(stato))
        out.push({
          cliente: c.nome,
          risorsa: res,
          stato,
          cpl: c.cpl || '',
          pm1: c.pm1 || '',
          pm2: c.pm2 || ''
        });
    });
  });
  return out;
}

function collectScadenze() {
  const out = [];
  state.clients.forEach((c) => {
    (c.scadenze || []).forEach((s) => {
      out.push({ ...s, cliente: c.nome, cpl: c.cpl, giorni: daysUntil(s.data) });
    });
    if (c.contratto?.fine) {
      out.push({
        id: 'contr-' + c.nome,
        titolo: 'Fine contratto',
        tipo: 'Contratto',
        data: c.contratto.fine,
        note: c.contratto.numero || '',
        completata: false,
        cliente: c.nome,
        cpl: c.cpl,
        giorni: daysUntil(c.contratto.fine),
        virtual: true
      });
    }
  });
  return out;
}

function renderDashboard() {
  $('#kpiClienti').textContent = state.clients.length;

  let attivi = 0,
    daRich = 0;
  state.clients.forEach((c) => {
    Object.values(c.accessi || {}).forEach((v) => {
      const k = (v || '').toLowerCase().trim();
      if (k === 'sì' || k === 'si') attivi++;
      if (k === 'da richiedere' || k === 'richieste') daRich++;
    });
  });
  $('#kpiAttivi').textContent = attivi;
  $('#kpiDaRichiedere').textContent = daRich;
  $('#kpiRisorse').textContent = state.resources.length;
  const badgeAzioni = $('#badgeAzioni');
  if (badgeAzioni) badgeAzioni.textContent = daRich;

  const allDeadlines = collectScadenze();
  const upcoming30 = allDeadlines.filter(
    (s) => !s.completata && s.giorni !== null && s.giorni >= 0 && s.giorni <= 30
  );
  const upcoming90 = allDeadlines.filter(
    (s) => !s.completata && s.giorni !== null && s.giorni >= -30 && s.giorni <= 90
  );
  $('#kpiScadenze').textContent = upcoming30.length;
  const scadBadge = $('#badgeScadenze');
  if (scadBadge) {
    if (upcoming30.length > 0) {
      scadBadge.classList.remove('hidden');
      scadBadge.textContent = upcoming30.length;
    } else scadBadge.classList.add('hidden');
  }

  const perCount = {};
  state.clients.forEach((c) => {
    const perimetri = c.perimetri && c.perimetri.length ? c.perimetri : ['Non definito'];
    perimetri.forEach((p) => {
      perCount[p] = (perCount[p] || 0) + 1;
    });
  });
  renderChartIn('chartAmbienti', perCount, 'cv-ambienti');

  const cplCount = {};
  state.clients.forEach((c) => {
    const p = (c.cpl || 'Non assegnato').trim() || 'Non assegnato';
    cplCount[p] = (cplCount[p] || 0) + 1;
  });
  renderChartIn('chartPM', cplCount, 'cv-cpl');

  // --- "Le tue azioni aperte" (filtrato in base al ruolo) ---
  const me = getCurrentUser();
  const myActionListEl = $('#myActionList');
  const myActionsTitle = $('#myActionsTitle');
  if (myActionListEl && me) {
    let myActions = collectActions();
    if (me.role === 'admin') {
      // Admin vede le azioni dei clienti dove è CPL
      myActions = myActions.filter((a) => a.cpl === me.name);
      myActionsTitle.textContent = `Le tue azioni aperte (come CPL)`;
    } else {
      // Utente vede le azioni dove la sua risorsa è coinvolta
      myActions = myActions.filter((a) => a.risorsa === me.resourceName);
      myActionsTitle.textContent = `Le tue azioni aperte (su di te)`;
    }
    const top = myActions.slice(0, 10);
    myActionListEl.innerHTML = top.length
      ? top
          .map(
            (a) => `
          <div class="action-item" data-cliente="${escapeHtml(a.cliente)}">
            <span class="status ${statusClass(a.stato)}">${escapeHtml(a.stato)}</span>
            <span class="a-cliente">${escapeHtml(a.cliente)}</span>
            <span class="a-risorsa">${escapeHtml(a.risorsa)}</span>
            <span class="a-pm">${escapeHtml(a.cpl || '')}</span>
          </div>`
          )
          .join('') +
        (myActions.length > top.length
          ? `<p class="muted" style="margin-top:8px;">+${myActions.length - top.length} altre — vedi vista completa</p>`
          : '')
      : '<p class="muted">Nessuna azione aperta a te assegnata.</p>';
    myActionListEl.querySelectorAll('.action-item').forEach((el) => {
      el.addEventListener('click', () => openModal(el.dataset.cliente));
    });
  }

  // --- Top 5 risorse da gestire (solo admin) ---
  const topRisorseEl = $('#topRisorseList');
  if (topRisorseEl && isAdmin()) {
    const counts = {};
    collectActions().forEach((a) => {
      if (a.stato === 'Da richiedere') counts[a.risorsa] = (counts[a.risorsa] || 0) + 1;
    });
    const top5 = Object.entries(counts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5);
    topRisorseEl.innerHTML = top5.length
      ? '<div class="top-risorse-list">' +
        top5
          .map(
            ([nome, count]) => `
          <div class="top-risorse-row">
            <span class="nome">${escapeHtml(nome)}</span>
            <span class="count">${count}</span>
          </div>`
          )
          .join('') +
        '</div>'
      : '<p class="muted">Nessuna utenza da richiedere.</p>';
  }

  // --- Clienti senza CPL (solo admin) ---
  const orphanEl = $('#orphanClientsList');
  if (orphanEl && isAdmin()) {
    const orphans = state.clients.filter((c) => !c.cpl || !c.cpl.trim());
    orphanEl.innerHTML = orphans.length
      ? orphans
          .slice(0, 8)
          .map(
            (c) => `
          <div class="action-item" data-cliente="${escapeHtml(c.nome)}">
            <span class="status status-darichiedere">Senza CPL</span>
            <span class="a-cliente">${escapeHtml(c.nome)}</span>
            <span class="a-risorsa">${(c.perimetri || []).join(', ') || '—'}</span>
          </div>`
          )
          .join('') +
        (orphans.length > 8
          ? `<p class="muted" style="margin-top:8px;">+${orphans.length - 8} altri</p>`
          : '')
      : '<p class="muted">Tutti i clienti hanno un CPL assegnato.</p>';
    orphanEl.querySelectorAll('.action-item').forEach((el) => {
      el.addEventListener('click', () => openModal(el.dataset.cliente));
    });
  }

  const dashScad = upcoming90.sort((a, b) => a.giorni - b.giorni).slice(0, 12);
  // G2: timeline orizzontale invece di lista flat
  $('#scadenzeList').innerHTML = dashScad.length
    ? `<div class="scad-timeline">${dashScad
        .map(
          (s) => `
        <div class="scad-timeline-card ${deadlinePillClass(s.giorni)}" data-cliente="${escapeHtml(s.cliente)}">
          <span class="scad-tl-when">${escapeHtml(formatGiorni(s.giorni))}</span>
          <span class="scad-tl-title" title="${escapeHtml(s.titolo)}">${escapeHtml(s.titolo)}</span>
          <span class="scad-tl-meta">${escapeHtml(s.cliente)}</span>
          <span class="scad-tl-meta">${escapeHtml(fmtDate(s.data))}</span>
        </div>`
        )
        .join('')}</div>`
    : '<div class="scad-tl-empty">Nessuna scadenza imminente.</div>';
  $('#scadenzeList')
    .querySelectorAll('.scad-timeline-card')
    .forEach((el) => {
      el.addEventListener('click', () => isAdmin() && openModal(el.dataset.cliente, 'scadenze'));
    });

  // G3: Heatmap contratti (mese × densità) — render se il container esiste in vista
  if (typeof renderHeatmap === 'function') renderHeatmap('chartHeatmap');

  const auditEl = $('#auditRecent');
  if (auditEl) {
    const recent = state.auditLog.slice(0, 8);
    auditEl.innerHTML = recent.length
      ? recent
          .map(
            (a) => `
        <div class="action-item">
          <span class="audit-action ${a.action}">${escapeHtml(a.action)}</span>
          <span class="a-cliente">${escapeHtml(a.target || a.entity)}</span>
          <span class="a-risorsa">${escapeHtml(a.user)}</span>
          <span class="a-pm">${escapeHtml(fmtDateTime(a.timestamp))}</span>
        </div>`
          )
          .join('')
      : '<p class="muted">Nessuna modifica registrata.</p>';
  }

  // F-a / F5: pannello "Cosa richiede attenzione oggi" (solo admin).
  if (isAdmin() && typeof computeAlerts === 'function' && typeof renderAreaAlerts === 'function') {
    const p = typeof getUserPrefs === 'function' ? getUserPrefs() || {} : {};
    const alerts = computeAlerts(state.clients, {
      contractDays: Number(p.area_contract_days != null ? p.area_contract_days : 30),
      stuckDays: Number(p.area_stuck_days != null ? p.area_stuck_days : 14)
    });
    renderAreaAlerts('dashAreaAlerts', alerts);
    const sub = $('#attentionSub');
    if (sub) {
      const crit = alerts.filter((a) => a.level === 'critical').length;
      sub.textContent = !alerts.length
        ? 'Tutto sotto controllo'
        : `${alerts.length} ${alerts.length === 1 ? 'avviso' : 'avvisi'}${crit ? ` · ${crit} da gestire subito` : ''}`;
    }
    // F-b: registra lo snapshot KPI di oggi per i trend storici (best-effort).
    if (typeof recordKpiSnapshot === 'function') recordKpiSnapshot();
  }
}

Object.assign(globalThis, {
  renderDashboard,
  collectActions,
  collectScadenze,
  deadlinePillClass,
  formatGiorni,
  renderBarChart,
  renderChartIn
});
export {};
